import { literal, struct } from 'io-ts/Decoder';

import { DimensionLine } from '../scale/DimensionLine';

/**
 * Sent when the overall dimension lines are changed
 */
export const ChangeOverallDimensionLine = struct({
	type: literal('change-overall-dimension-line'),
	xDimension: DimensionLine,
	yDimension: DimensionLine,
});
